import * as React from 'react';
import { Component } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS,
  MESSAGE_INVITATION_STATUS_SERVER_TO_CLIENT_MAPPING
} from 'Src/consts/message';
import { MAX_CLUB_PRIORITY, MIN_CLUB_PRIORITY } from 'Src/consts/club';

interface Props {
  onCancel: () => void;
  onSubmit: (data: { invitationStatus: string; priority?: number }) => void;
  message: any;
}

const ClubMessageStatusSchema = Yup.object().shape({
  invitationStatus: Yup.string().required('Required'),
  priority: Yup.number()
    .max(10)
    .min(0)
});

export class ClubMessageStatusForm extends Component<Props> {
  renderMessagePriorityOptions() {
    let options = [];

    for (let index = MIN_CLUB_PRIORITY; index <= MAX_CLUB_PRIORITY; index++) {
      options.push(
        <option key={index} value={index}>
          {index}
        </option>
      );
    }

    options.unshift(
      <option key={`empty_priority`} value={0}>
        Not select
      </option>
    );

    return options;
  }

  render() {
    const { message } = this.props;
    const { invitationStatus, priority } = message;

    const clubMessageStatusForm = {
      invitationStatus:
        invitationStatus === CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS.REJECTED
          ? CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS.REJECTED
          : CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS.ACCEPTED,
      priority: typeof priority !== 'undefined' ? priority : 0
    };

    return (
      <Formik
        initialValues={clubMessageStatusForm}
        validationSchema={ClubMessageStatusSchema}
        onSubmit={values => this.props.onSubmit(values)}
      >
        {({ touched, errors, values, setFieldValue }) => (
          <Form className="clubsInvitationStatusForm">
            <div className="clubsInvitationStatusForm__intro">
              Choose the response status for this invitation. Priority is only used for accepted bookings.
            </div>
            <fieldset>
              <legend>Status</legend>
              <div className="clubsInvitationStatusForm__chips">
                {[
                  CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS.ACCEPTED,
                  CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS.REJECTED
                ].map(status => (
                  <button
                    type="button"
                    key={status}
                    className={values.invitationStatus === status ? 'isSelected' : ''}
                    onClick={() => setFieldValue('invitationStatus', status)}
                  >
                    {MESSAGE_INVITATION_STATUS_SERVER_TO_CLIENT_MAPPING[status]}
                  </button>
                ))}
              </div>
              {touched.invitationStatus && errors.invitationStatus ? (
                <div className="clubsInvitationStatusForm__error">{String(errors.invitationStatus)}</div>
              ) : null}
            </fieldset>

            {values.invitationStatus === CLUB_PARTICIPATION_MESSAGE_INVITATION_STATUS.ACCEPTED && (
              <label className="clubsInvitationStatusForm__field">
                <span>Priority</span>
                <Field component="select" name="priority">
                  {this.renderMessagePriorityOptions()}
                </Field>
                {touched.priority && errors.priority ? (
                  <small className="clubsInvitationStatusForm__error">{String(errors.priority)}</small>
                ) : null}
              </label>
            )}

            <div className="clubsInvitationStatusForm__actions">
              <button type="button" className="clubsDsBtn clubsDsBtnGhost" onClick={this.props.onCancel}>
                Cancel
              </button>
              <button type="submit" className="clubsDsBtn clubsDsBtnPrimary">
                Save changes
              </button>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}
